var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddConnectPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5461 2.18662L16.7179 5.35841C17.1089 5.74945 17.1089 6.38348 16.7179 6.77454L8.75653 14.7362C8.62969 14.8631 8.47111 14.9535 8.29737 14.9981L4.03086 16.0929C3.29338 16.2821 2.62287 15.6116 2.8121 14.8741L3.90683 10.6075C3.95141 10.4337 4.04185 10.2751 4.16869 10.1483L12.1301 2.18663C12.5211 1.79558 13.1551 1.79558 13.5461 2.18662ZM12.8381 3.17791L5.05708 10.9592L4.0601 14.8449L7.94564 13.8478L15.7266 6.06648L12.8381 3.17791Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1225 5.78528C13.2789 5.94169 13.2789 6.19529 13.1225 6.35171L8.31632 11.1581C8.15991 11.3145 7.90631 11.3145 7.74989 11.1581C7.59347 11.0017 7.59346 10.7481 7.74988 10.5917L12.5561 5.78529C12.7125 5.62887 12.9661 5.62886 13.1225 5.78528Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14759 12.1935C6.30401 12.0371 6.55761 12.0371 6.71403 12.1935L8.31609 13.7956C8.4725 13.952 8.4725 14.2056 8.31608 14.3621C8.15966 14.5185 7.90606 14.5185 7.74964 14.362L6.14758 12.7599C5.99117 12.6035 5.99117 12.3499 6.14759 12.1935Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.551 0.300961C14.7856 0.0663398 15.166 0.0663474 15.4006 0.300978L18.6048 3.50523C18.8394 3.73986 18.8394 4.12026 18.6047 4.35488C18.3701 4.5895 17.9897 4.5895 17.7551 4.35487L14.551 1.15062C14.3163 0.915985 14.3163 0.535582 14.551 0.300961Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddConnectPen);
export default __webpack_public_path__ + "static/media/addConnectPen.b59eaff2a65aef87426845c097d72599.svg";
export { ForwardRef as ReactComponent };